<script>
    import { WriteContents, EditContents } from '../../../script/handle/write'

    export let OnWait, ShowDataIssueModal, Num, CheckMonster, CheckAddInfo

	let dialog;

    $: if (dialog && ShowDataIssueModal) {
        dialog.showModal(); 
    }

    // Modal 종료
	function closeModal() {
        OnWait = false
		ShowDataIssueModal = false
		dialog.close()
	}

    async function onWrite() {
        await WriteContents(true)
    }

    async function onEdit() {
        await EditContents(Num, true)
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
	bind:this={dialog}
	on:close={() => closeModal()}
	on:click|self={() => closeModal()}
    class='issueModal'
>
	<!--<div class='monsterModal' on:click|stopPropagation>-->
    <div class="title">공략 작성 이슈</div>

    <div class="issue">
        미선택 항목이 있습니다.<br>
        (그대로 작성은 가능하나 '공란' 게시글로 지정됩니다.)

        {@html CheckMonster}
        {@html CheckAddInfo}
    </div>


    <!-- svelte-ignore a11y-autofocus -->
    <div style="text-align: center;">
        <button class='close' on:click={() => dialog.close()}>닫기</button>

        {#if Num > 0}
            <button class='write' autofocus on:click={onEdit} >
                수정
            </button>
        {:else}        
            <button class='write' autofocus on:click={onWrite} >
                저장
            </button>
        {/if}
    </div>
</dialog>

<style lang='scss'>
    dialog {
        border-radius: 4px;
        border: 1px solid #ffffff;
        padding: 0;
        background-color: $cl1;
        color: #ffffff;

        & > div {
            padding: 10px;
        }

        &::backdrop {
            background: rgba(0, 0, 0, 0.8);
        }

        &[open] {
            animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes zoom {
            from {
                transform: scale(0.95);
            }
            to {
                transform: scale(1);
            }
        }
        &[open]::backdrop {
            animation: fade 0.2s ease-out;
        }
        @keyframes fade {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }

    .issueModal {
        width: 40%;
        min-width: 300px;
        height: fit-content;

        .title {
            width: calc(100% - 20px);
            color: $cl4;
            font-size: 24px;
            font-family: aggro;
            text-align: center;
        }

        .issue {
            font-size: 16px;
            font-family: aggro;

            :global(p) {
                margin: 0px;
                margin-top: 12px;
            }

            :global(ul) {
                margin: 4px 0px;
                padding: 0;
                list-style: none;
                display:flex;
                flex-flow: row nowrap;

                :global(li) {
                    color: $cl4;
                    font-size: 14px;
                    font-family: pretendard;

                    &::after {
                        content: "|";
                        margin: 0px 5px;
                        color: $cl2;
                    }
                    &:last-child::after{
                        content: "";
                    }
                }

            }
        }
        
        button {
            background: none;
            margin: 0px 10px;
            padding: 8px 10px;
            padding-bottom: 5px;
            border: 2px solid $cl3;
            color: $cl2;
            font-size: 18px;
            font-family: aggro;

            &.close {
                width: calc(30% - 20px - 4px - 10px);
            }
            &.write {
                width: calc(70% - 20px - 4px - 10px);
            }

            &:hover {
                background: $cl3;
            }
        }
    }
</style>
